import { css, CSSResultGroup, html, LitElement } from "lit";
import { customElement, property } from "lit/decorators.js";

@customElement("basic-button")
export class BasicButton extends LitElement {
	static readonly styles: CSSResultGroup = css`
        :host { display: block; }
        button {
            width: 100%;
            font-family: var(--font-headline);
            font-size: 1rem;
            color: black;
            background: white;
            border: var(--border-default);
            padding: 10px 20px;
            border-radius: var(--border-radius);
            cursor: pointer;
            box-shadow: var(--shadow-default);
            transition: all 0.3s ease;
        }
        
        button:hover:not(:disabled) {
            background: var(--color-sand);
            color: white;
        }
        
        button:disabled {
            opacity: 0.6;
            cursor: not-allowed;
        }

        :host([small]) button {
            padding: 6px 10px;
            font-size: 0.85rem;
        }

        :host([active]) button {
            background: var(--color-sand);
            color: white;
        }
    `;

	@property() type: "button" | "submit" = "button";
	@property({ type: Boolean, reflect: true }) disabled = false;
	@property({ type: Boolean, reflect: true }) small = false;
	@property({ type: Boolean, reflect: true }) active = false;

	render() {
		return html`
            <button type="${this.type}" ?disabled="${this.disabled}">
                <slot></slot>
            </button>
        `;
	}
}

export default BasicButton;